"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.publicNewsletterSchema = exports.newsletterSubscriberSchema = void 0;
const zod_1 = require("zod");
// Full DB row schema for NewsletterSubscriber
exports.newsletterSubscriberSchema = zod_1.z.object({
    id: zod_1.z.string().optional(),
    email: zod_1.z.string().email(),
    active: zod_1.z.boolean().default(true),
});
// API verbatim public form schema (source of truth: apps/api/src/common/schemas.ts)
exports.publicNewsletterSchema = zod_1.z.object({
    email: zod_1.z.string().email().max(255),
});
//# sourceMappingURL=newsletter-subscriber.js.map